import { Actions, createStore } from '@bpd-library/utilities';

interface State {
    flyins: {
        [key: string]: {
            active: boolean;
        };
    };
}

type FlyinStoreAction = 'addFlyIn' | 'openFlyIn' | 'closeFlyIn';

const initialState: State = {
    flyins: {},
};

const actions: Actions<FlyinStoreAction, State> = {
    addFlyIn: (state: State, payload: { id: string }) => {
        state.flyins = {
            ...state.flyins,
            [payload.id]: {
                active: false,
            },
        };

        return state;
    },
    openFlyIn: (state: State, payload: { id: string }) => {
        state.flyins = {
            ...state.flyins,
            [payload.id]: {
                active: true,
            },
        };

        return state;
    },
    closeFlyIn: (state: State, payload: { id: string }) => {
        state.flyins = {
            ...state.flyins,
            [payload.id]: {
                active: false,
            },
        };
        return state;
    },
};

export const flyinStore = createStore<State, FlyinStoreAction>({
    initialState,
    actions,
});

export const addFlyin = (id: string) => {
    flyinStore.dispatch('addFlyIn', { id });
};

export const closeFlyin = (id: string) => {
    flyinStore.dispatch('closeFlyIn', { id });
};

export const openFlyin = (id: string) => {
    flyinStore.dispatch('openFlyIn', { id });
};
